import { map, Observable, take, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { FaqCategoryDto } from '@feature/_app_modules/responsive-faq/faq.types';

@Injectable({
  providedIn: 'root'
})

export class FaqCategoryHttpService {
    constructor(
        private readonly urlProvider: UrlBuilderService,
        private readonly http: HttpClient
    ){}

    loadCategories(): Observable<FaqCategoryDto[]> {
        return this.http.get<FaqCategoryDto[]>(this.urlProvider.getUrl('admin/faq-categories/all'));
    }

    saveCategories(categories: FaqCategoryDto[]): Observable<boolean> {
        const url = this.urlProvider.getUrl('admin/faq-categories');
        return this.http.post(url, categories).pipe(take(1), map(()=> true), tap(() => this.loadCategories()));
    }
}